










import Vue from 'vue'
import Component from 'vue-class-component'
import { Action } from 'vuex-class'

import UserInterface2FolderDataTable from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-2-folder-data-table.vue'

import {
  DataTableFile,
  itemTypeFolder,
  itemTypeAccount
} from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

import {
  JOB_EMPLOYMENT_POSITION_TYPE_LIST
} from '../../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-constants/helper-constants-2'

import { DigitalCurrencyAccount } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-1-service-data-structure/service-data-structure-1'
import { LIST_TYPE_WILLING_TO_RECEIVE_PROMOTIONS } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-1-algorithms/algorithms-type-26-get-digital-currency-account-list/get-digital-currency-account-list-1'
import { JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION, JOB_EMPLOYMENT_RESOURCE_PROMOTION } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-3-constants/constants-1-account-description'

const namespace = 'digitalCurrency'

@Component({
  components: {
    UserInterface2FolderDataTable
  }
})
class JobEmploymentResourceItem3FindEmployeesToHire extends Vue {

  @Action('getDigitalCurrencyAccountList', { namespace }) getDigitalCurrencyAccountList?: any
  @Action('getDigitalCurrencyAccountBySearchText', { namespace }) getDigitalCurrencyAccountBySearchText?: any

  initialFile: DataTableFile = new DataTableFile()

  currentSelectedItem: DataTableFile = new DataTableFile()

  mounted () {
    this.initializeInitialFile()
  }

  initializeInitialFile () {

    const jobEmploymentTypeMap = JOB_EMPLOYMENT_POSITION_TYPE_LIST.reduce((map: any, obj: any, index: number) => (map[obj.jobEmploymentPositionName] = JOB_EMPLOYMENT_POSITION_TYPE_LIST[index], map), {})
    for (let itemId in jobEmploymentTypeMap) {
      if (!jobEmploymentTypeMap.hasOwnProperty(itemId)) {
        continue
      }
      const fileItem = new DataTableFile()
      fileItem.itemId = itemId
      fileItem.itemName = itemId
      fileItem.itemIconImageUrl = jobEmploymentTypeMap[itemId].jobEmploymentPositionIconId
      fileItem.itemType = itemTypeFolder
      fileItem.itemData = {
        showCustomSearchTextField: true,
        onUpdateCustomSearchTextField: this.onUpdateCustomSearchTextField
      }
      jobEmploymentTypeMap[itemId] = fileItem
    }

    this.initialFile.fileVariableTable = jobEmploymentTypeMap
    this.initialFile.itemData = {
      showSearchTextField: false,
      pageTitle: 'What Type Of Jobs Are You Hiring For?'
    }

    return this.initialFile
  }

  async onUpdateCustomSearchTextField (searchText: string) {

    if (!searchText) {
      Vue.set(this.initialFile.fileVariableTable![this.currentSelectedItem.itemId], 'fileVariableTable', (this.initialFile.fileVariableTable![this.currentSelectedItem.itemId] as any).initialFileVariableTable)
      return
    }

    let searchResultList: DigitalCurrencyAccount[] = await this.getDigitalCurrencyAccountBySearchText({
      searchText,
      options: {
        filters: `${JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION}.willingToReceivePromotionsOfType:"${this.currentSelectedItem.itemId}"`
      }
    })

    // Delete Previous Results
    Vue.set(this.initialFile.fileVariableTable![this.currentSelectedItem.itemId], 'fileVariableTable', {})

    // Add New Results
    for (let i = 0; i < searchResultList.length; i++) {
      const digitalCurrencyAccount = searchResultList[i]
      if (!digitalCurrencyAccount) {
        continue
      }
      const accountFile = new DataTableFile()
      accountFile.itemId = digitalCurrencyAccount.accountId
      accountFile.itemName = digitalCurrencyAccount.accountName
      accountFile.itemIconImageUrl = digitalCurrencyAccount.accountProfilePictureUrl
      accountFile.itemType = itemTypeAccount
      Vue.set(this.initialFile.fileVariableTable![this.currentSelectedItem.itemId].fileVariableTable!, accountFile.itemId, accountFile)
    }
  }

  async onSelectedFolderDataTableItem (selectedItem: DataTableFile) {

    if (!selectedItem) {
      return
    }

    if (selectedItem.itemType !== itemTypeFolder) {
      return
    }

    if (!this.initialFile.fileVariableTable![selectedItem.itemId]) {
      return
    }

    this.currentSelectedItem = selectedItem

    if (!(this.initialFile.fileVariableTable![selectedItem.itemId] as any).initialFileVariableTable) {
      (this.initialFile.fileVariableTable![selectedItem.itemId] as any).initialFileVariableTable = {}
    }

    const digitalCurrencyAccountList: DigitalCurrencyAccount[] = await this.getDigitalCurrencyAccountList({
      listType: LIST_TYPE_WILLING_TO_RECEIVE_PROMOTIONS,
      options: {
        promotionType: JOB_EMPLOYMENT_RESOURCE_PROMOTION,
        promotionGenreType: selectedItem.itemId
      }
    })

    for (let i = 0; i < digitalCurrencyAccountList.length; i++) {
      const digitalCurrencyAccount = digitalCurrencyAccountList[i]
      const accountFile = new DataTableFile()
      accountFile.itemId = digitalCurrencyAccount.accountId
      accountFile.itemName = digitalCurrencyAccount.accountName
      accountFile.itemIconImageUrl = digitalCurrencyAccount.accountProfilePictureUrl
      accountFile.itemType = itemTypeAccount
      // this.initialFile.fileVariableTable![selectedItem.itemId].fileVariableTable![accountFile.itemId] = accountFile
      Vue.set(this.initialFile.fileVariableTable![selectedItem.itemId].fileVariableTable!, accountFile.itemId, accountFile)
      Vue.set((this.initialFile.fileVariableTable![selectedItem.itemId] as any).initialFileVariableTable, accountFile.itemId, accountFile)
    }
  }
}

export default JobEmploymentResourceItem3FindEmployeesToHire

